import axios from 'axios';
import { STORE_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

export const getBrandStoreOfferConfig = (brandId, storeId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/offer/brand/' +
      brandId +
      '/store/' +
      storeId +
      '/offer',
    headers: getHeaders(),
  });
};

export const addBrandStoreBrandOfferConfig = (brandId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/offer/brand/' +
      brandId +
      '/store-brand-offer',
    // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const updateBrandStoreBrandOfferConfig = (brandId, data) => {
  return axios({
    method: 'put',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/offer/brand/' +
      brandId +
      '/store-brand-offer',
    // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};